import millisecondsToSeconds from './millisecondsToSeconds';

export default millisecondsToSeconds;
